module.exports = __webpack_public_path__ + "f95e744f8dc1060e28c92e7afc8644da.svg";